import { combineReducers } from 'redux';
import key from './licenseKey.reducer';

const reducer = combineReducers({
	key
});

export default reducer;
